import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "推荐榜单", to: "/rankings" },
  { label: "高分漫画", to: "/category/high-rated" },
  { label: "冷门佳作", to: "/category/hidden-gems" },
  { label: "补番清单", to: "/category/checklist" },
  { label: "关于我们", to: "/about" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/rankings?q=${encodeURIComponent(q)}` : "/rankings");
    setOpen(false);
  };

  return (
    <header
      className={`sticky top-0 z-40 w-full border-b transition-colors ${
        scrolled ? "border-background-200 bg-background-50/95 backdrop-blur" : "border-transparent bg-background-50"
      }`}
    >
      <div className="container-page flex h-16 items-center justify-between gap-4 md:h-[76px]">
        <Link to="/" className="flex shrink-0 items-center gap-2.5" onClick={() => setOpen(false)}>
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 font-heading text-xl font-bold text-background-50">
            漫
          </span>
          <span className="leading-tight">
            <span className="block font-heading text-lg font-bold text-foreground-950 md:text-xl">
              我爱漫画网
            </span>
            <span className="hidden text-[11px] tracking-wide text-foreground-500 sm:block">
              告别剧荒 · 找好漫画
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <form
            onSubmit={submitSearch}
            className="hidden items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-2 md:flex"
            role="search"
          >
            <i className="ri-search-line text-sm text-foreground-500" />
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜作品 / 类型..."
              className="w-32 bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
            />
          </form>
          <Link
            to="/contact"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            投稿交流
          </Link>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-xl text-foreground-800 hover:bg-background-100 lg:hidden"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="container-page flex flex-col gap-1 py-4" aria-label="移动端导航">
            <form onSubmit={submitSearch} className="mb-2 flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2.5">
              <i className="ri-search-line text-sm text-foreground-500" />
              <input
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜作品 / 类型..."
                className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
              />
            </form>
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm font-medium ${
                    isActive ? "bg-primary-50 text-primary-700" : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
            >
              投稿交流
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}